<script>
import appConfig from "@/app.config";
import NewLocalInvoice from "@/router/views/local-invoices/newLocalInvoiceComponent"
import Layout from "../../layouts/main";


export default {
  page: {
    title: "Bon de  Commande",
    meta: [{ name: "description", content: appConfig.description }]
  },

  components: { Layout,NewLocalInvoice },

  props:{
    localInvoiceId:{
      type:Number,
      default:0
    },

    showTransfer:{
      type: Boolean,
      default:null
    }
  }


}

</script>

<template>
  <Layout>
     <NewLocalInvoice :localInvoiceId=this.localInvoiceId />
  </Layout>
</template>